const hideElement = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
        element.style.display = 'none';
    }
};

export default hideElement;